import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { CORNERS } from 'vars/corners'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { SHADOW } from 'vars/shadow'

export const SearchAutocompleteMenuSC = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
  max-width: 904px;
  margin-top: var(${FIXED_INDENTS.INDENT_20});
  padding: var(${FIXED_INDENTS.INDENT_30}) 0;
  border-radius: var(${CORNERS.CORNERS_10});
  background: var(${COLOR.SURFACE_DARK_4});
  box-shadow: var(${SHADOW.NORMAL});
`
